import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function ImgConvertPrivacyPolicyZhTw() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 隱私政策

"圖片格式轉換應用程式"（以下簡稱「本應用程式」）尊重使用者的隱私，並最大限度地注意保護個人資訊。本應用程式不收集使用者的個人資訊，並採取措施保護使用者的資料。本隱私政策（以下簡稱「本政策」）規定了本應用程式中資訊的處理方式。

## 第1條（個人資訊的收集和管理方針）

本應用程式不收集使用者的任何個人資訊（如姓名、地址、電話號碼等）。應用程式內的所有功能都是在不收集個人資訊的前提下設計的。此外，為了保護使用者的隱私，我們根據個人資訊保護法，不收集或儲存任何可以識別個人身份的資訊。

## 第2條（圖片資料的處理）

在本應用程式中，使用者轉換的所有圖片資料僅在使用者裝置內處理，不會傳輸到外部伺服器。圖片轉換處理完全在本地進行，轉換前後的圖片資料僅保存在裝置中。我們無法存取使用者的圖片資料。

## 第3條（廣告投放）

本應用程式通過Google AdMob投放廣告。在廣告投放過程中，Google的系統可能會自動收集資料以優化廣告投放，但這些資料按照Google的隱私政策進行管理。本應用程式不保留任何與廣告投放相關的個人資訊。詳情請參閱Google的隱私政策。

## 第4條（隱私政策的變更）

本應用程式可能會不時審查本政策的內容，並根據法律修訂和應用程式功能的變更來改變本政策，以提高使用者隱私保護。當發生變更時，我們將通過在本應用程式內發布最新的隱私政策來通知使用者，並在發布的同時生效。請使用者定期查看本政策。

## 第5條（聯絡方式）

如果您對本政策有任何問題或疑慮，請通過以下地址與我們聯絡：

電子郵箱：linappworks@gmail.com
  `;

  return (
    <Container>
      <Content>
        <Title>Privacy Policy</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default ImgConvertPrivacyPolicyZhTw; 
